import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const SubTotal = ({ subTotalPrice }) => {
  return (
    <div className="border-start h-100 ps-2">
      <h5 className="d-flex justify-content-between w-100">
        Subtotal
        <span>{subTotalPrice ? subTotalPrice : 0} TK</span>
      </h5>
      <Button
        type="button"
        as={Link}
        to="/checkout"
        style={{
          backgroundColor: "#7dcfb6",
          padding: "10px",
          marginBottom: "10px",
          fontSize: "18px",
          textAlign: "center",
          fontWeight: "bold",
          marginTop: "2rem",
          letterSpacing: "1px",
          width: "100%",
          border: "none",
        }}
      >
        Pay Now
      </Button>
    </div>
  );
};

export default SubTotal;
